<template>
	<main class="token-request">
		<div class="token-request__header">
			<div class="token-request__header-icon">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
					<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
					<path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.896 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<div>
				<h1 class="token-request__title">Deal Information</h1>
				<p class="token-request__subtitle">Fill in the details of the {{ requestType }} you're creating</p>
			</div>
		</div>
		
		<form @submit.prevent="checkFormValidation" class="token-request__form">
			<div class="token-request__section">
				<div class="token-request__section-header">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
						<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2"/>
						<path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<h2>{{ requestType }} Information</h2>
				</div>
			</div>
			
			<div class="token-request__content">
				<div class="md:tw-w-[164px]">
					<DragNDrop
						:validate="isValidated"
						accept="image/png, image/jpeg, image/jpg"
						:currentValue="token.image"
						:startUpload="uploadImage"
						@re-upload="uploadImage = false"
						@upload-complete="uploadComplete"
						@file-added="setImage"
						@upload-error="imageUploadError"
					/>
				</div>
				<div class="tw-w-full md:tw-w-8/12 tw-pt-0 lg:tw-pt-0 tw-max-w-[435px]">
					<InputField
						:label="requestType + ' Name'"
						:validate="validateForm"
						class="tw-mb-6"
						type="text"
						name="name"
						:currentValue="token.name"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<InputField
						label="Symbol"
						:validate="validateForm"
						class="tw-mb-6"
						type="text"
						name="symbol"
						:currentValue="token.symbol"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<Dropdown
						class="tw-mb-6"
						name="investment_type"
						label="Investment Type"
						:validate="validateForm"
						:currentValue="token.investment_type"
						:options="investmentTypes"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<Dropdown
						class="tw-mb-6"
						name="country"
						label="Country"
						:validate="validateForm"
						:currentValue="token.country"
						:options="countryRegionState"
						v-bind="{
							isObject: true,
							objectValue: { label: 'countryName', value: 'countryName' },
						}"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<Dropdown
						class="tw-mb-6"
						name="currency"
						label="Currency"
						:validate="validateForm"
						:currentValue="token.currency"
						v-bind="{
							isObject: true,
							objectValue: { label: 'name', value: 'value' },
						}"
						:options="currencies"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<Dropdown
						v-if="token.investment_type !== 'SAFE'"
						class="tw-mb-6"
						name="payout_frequency"
						label="Payout Frequency"
						:validate="validateForm"
						:currentValue="token.payout_frequency"
						v-bind="{
							isObject: true,
							objectValue: { label: 'name', value: 'value' },
						}"
						:options="payoutFrequencies"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<template
						v-if="
							token.investment_type === 'Debt' ||
							token.investment_type === 'Fixed Interest'
						"
					>
						<InputField
							label="Interest (%)"
							:validate="validateForm"
							class="tw-mb-6"
							type="text"
							name="interest"
							:currentValue="token.interest"
							:min-value="1"
							minValueErrorMessage="This field requires a minimum value of 1%"
							@input-changed="storeValue"
							:validateAsNumber="true"
							@is-valid="handleValidation"
						/>
						<InputField
							label="Investment Period"
							:validate="validateForm"
							class="tw-mb-6"
							type="text"
							name="tenor"
							:currentValue="token.tenor"
							@input-changed="storeValue"
							:validateAsNumber="true"
							@is-valid="handleValidation"
						/>
					</template>
					<InputField
						v-else
						label="Valuation"
						:validate="validateForm"
						class="tw-mb-6"
						type="text"
						name="valuation"
						:currentValue="valuation"
						@input-changed="storeValue"
						:validateAsNumber="true"
						@is-valid="handleValidation"
					/>
					<InputField
						v-if="token.investment_type"
						label="Risk"
						:validate="validateForm"
						class="tw-mb-6"
						type="text"
						name="risk"
						disabled
						:currentValue="token.risk"
						@input-changed="storeValue"
						@is-valid="handleValidation"
					/>
					<InputField
						label="Amount to be raised"
						:validate="validateForm"
						class="tw-mb-1"
						type="text"
						name="raise_amount"
						:minValue="minimumRaise"
						:currentValue="raise_amount"
						@input-changed="storeValue"
						:validateAsNumber="true"
						@is-valid="handleValidation"
					/>
					<p class="tw-text-[10px] tw-text-[#4F5877] tw-mb-6">
						Minimum {{ formatAmountToDollar(minimumRaise, 2, token.currency || 'USD') }} or
						equivalent
					</p>
					<div
						class="tw-flex tw-mt-6 tw-p-4 tw-bg-[#fdf2e7] tw-rounded tw-text-[#694521]"
					>
						<img
							src="https://res.cloudinary.com/djalafcj9/image/upload/v1634261166/getequityV2/pending_ctj1ke.png"
							alt="alert icon"
							class="tw-w-5 tw-h-5 tw-mr-2"
						/>
						<p class="tw-text-sm tw-font-[450]">
							The amount you are raising should not be greater than your
							valuation. Each token will be priced at {{ sharePriceFormatted }}.
						</p>
					</div>
					<div class="tw-my-8">
						<p class="tw-text-secondary tw-text-sm tw-font-medium tw-mb-4">
							Minimum Investment
						</p>
						<InputField
							label="Minimum Price"
							:validate="validateForm"
							class="tw-mb-1"
							type="text"
							name="min_buy"
							:currentValue="min_buy"
							@input-changed="storeValue"
							:validateAsNumber="true"
							@is-valid="handleValidation"
						/>
					</div>
					<p
						class="tw-text-black tw-flex tw-items-center tw-mb-3 tw-font-medium tw-cursor-pointer tw-text-sm"
						@click="token.secondaries = !token.secondaries"
					>
						<input
							class="tw-mr-3 token-request__checkbox"
							type="checkbox"
							name="secondaries"
							id="secondaries"
							v-model="token.secondaries"
						/>
						Allow Secondaries
						<Tooltip :text="secondariesTooltip" />
					</p>
					<!-- <p
            class="tw-text-black tw-flex tw-items-center tw-mb-3 tw-font-medium tw-cursor-pointer tw-text-sm"
            @click="deal_access = !deal_access"
          >
            <input
              class="tw-mr-3 token-request__checkbox tw-flex"
              type="checkbox"
              name="deal_access"
              id="deal_access"
              v-model="deal_access"
            />
            Make this deal public
            <Tooltip :text="dealAccessText" />
          </p> -->
					<div
						class="tw-flex tw-flex-wrap tw-gap-y-3 md:tw-gap-y-0 md:tw-gap-x-5 tw-w-full md:tw-items-start"
					>
						<p
							class="tw-text-black tw-flex tw-items-center tw-font-medium tw-mb-3 md:tw-mb-0 tw-cursor-pointer tw-text-sm"
							@click="buy_fee = !buy_fee"
						>
							<input
								class="tw-mr-3 token-request__checkbox tw-flex"
								:checked="tokenInfo?.buy_fee !== 1"
								type="checkbox"
								name="buy_fee"
								id="buy_fee"
								v-model="buy_fee"
							/>
							Defer fees to investors
							<Tooltip :text="buyFeesText" />
						</p>
						<div
							class="tw-flex-grow md:tw-flex-grow-0 md:tw-basis-1/2 md:tw-w-1/2"
							v-if="buy_fee"
						>
							<RangeField
								label="Percentage to defer"
								:validate="validateForm"
								class="tw-mb-1 tw-w-full"
								type="number"
								name="buy_fee"
								:currentValue="token.buy_fee"
								:minValue="1"
								:maxValue="5"
								:validateAsNumber="true"
								maxValueErrorMessage="Percentage cannot be greater than"
								@is-valid="handleValidation"
								@input-changed="storeValue"
							/>
							<p
								class="tw-mt-2 tw-text-[#323E67] tw-text-[13px] tw-leading-[150%] tw-font-[450]"
							>
								Range: 1% - 5%
							</p>
						</div>
					</div>

					<div
						class="tw-w-[153px] tw-mt-[70px]"
						v-if="tokenInfo?.status === 'Pending'"
					>
						<CustomButton
							:title="(tokenInfo ? 'Update ' : 'Create ') + requestType"
						/>
					</div>
					<div class="tw-w-[153px] tw-mt-[70px]">
						<CustomButton
							:title="(tokenInfo ? 'Update ' : 'Create ') + requestType"
						/>
					</div>
				</div>
			</div>
		</form>
		<Modal
			:show="showDealPreview"
			v-if="showDealPreview"
			:show-close-button="false"
			@close-modal="showDealPreview = false"
		>
			<div class="create-deal-preview__modal">
				<h1 class="tw-text-xl tw-text-secondary tw-leading-8">
					Request Summary
				</h1>
				<div class="tw-flex tw-justify-between tw-mt-10 border-bottom">
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light">Token Name</h2>
						<p class="tw-text-base">{{ token.name }}</p>
					</div>
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-right">
							Token Symbol
						</h2>
						<p class="tw-text-base tw-text-right">{{ token.symbol }}</p>
					</div>
				</div>
				<div class="tw-flex tw-justify-between tw-mt-10 border-bottom">
					<div
						class=""
						v-if="
							token.investment_type === 'Debt' ||
							token.investment_type === 'Fixed Interest'
						"
					>
						<h2 class="tw-text-xs tw-text-black-light">Investment Type</h2>
						<p class="tw-text-base">
							{{ token.investment_type }}
						</p>
					</div>
					<div class="" v-else>
						<h2 class="tw-text-xs tw-text-black-light">Valuation</h2>
						<p class="tw-text-base">
							{{ formatAmountToDollar(token.valuation, 2, token.currency || 'USD') }}
						</p>
					</div>
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-right">
							Amount of Shares To Sell (at {{ sharePriceFormatted }}/share)
						</h2>
						<p class="tw-text-base tw-text-right">
							{{ convertToLocale(token.raise_amount / sharePrice) }}
						</p>
					</div>
				</div>
				<div
					class="tw-flex tw-justify-between tw-mt-10 border-bottom"
					v-if="
						token.investment_type === 'Debt' ||
						token.investment_type === 'Fixed Interest'
					"
				>
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light">Interest Rate</h2>
						<p class="tw-text-base">{{ token.interest }}%</p>
					</div>
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-right">
							Investment Period
						</h2>
						<p class="tw-text-base tw-text-right">
							{{ token.tenor }} {{ token.tenor > 1 ? "months" : "month" }}
						</p>
					</div>
				</div>
				<div class="tw-flex tw-justify-between tw-mt-10">
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-left">
							Deal Country
						</h2>
						<p class="tw-text-base tw-text-left">
							{{ token.country }}
						</p>
					</div>
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light">Risk Level</h2>
						<p class="tw-text-base tw-text-right">
							{{ token.risk }}
						</p>
					</div>
				</div>
				<div class="tw-flex tw-justify-between tw-mt-10">
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-right">
							Deal type
						</h2>
						<p class="tw-text-base tw-text-left">
							{{ token.deal_access }}
						</p>
					</div>
					<div
						class=""
						v-if="
							token.investment_type !== 'Debt' &&
							token.investment_type !== 'Fixed Interest'
						"
					>
						<h2 class="tw-text-xs tw-text-black-light">Investment Type</h2>
						<p class="tw-text-base tw-text-right">
							{{ token.investment_type }}
						</p>
					</div>
					<div class="" v-else>
						<h2 class="tw-text-xs tw-text-black-light">Payout Frequency</h2>
						<p class="tw-text-base tw-text-right">
							{{ token.payout_frequency }}
						</p>
					</div>
				</div>
				<div class="tw-flex tw-justify-between tw-mt-10">
					<div class="">
						<h2 class="tw-text-xs tw-text-black-light tw-text-left">
							Currency
						</h2>
						<p class="tw-text-base tw-text-left">
							{{ getCurrency(token.currency) }}
						</p>
					</div>
					<div
						v-if="
							token.investment_type !== 'Debt' &&
							token.investment_type !== 'Fixed Interest'
						"
						class=""
					>
						<h2 class="tw-text-xs tw-text-black-light tw-text-right">
							Payout Frequency
						</h2>
						<p class="tw-text-base tw-text-right">
							{{ token.payout_frequency }}
						</p>
					</div>
				</div>
				<div
					class="tw-flex tw-flex-wrap tw-mt-8 md:tw-justify-between md:tw-w-96 tw-mx-auto"
				>
					<button
						class="tw-w-full tw-mb-4 md:tw-mb-0 md:tw-w-44 tw-font-medium tw-text-sm preview-button"
						@click="showDealPreview = false"
					>
						Go Back
					</button>
					<div class="tw-w-full md:tw-w-44">
						<CustomButton
							:title="
								tokenInfo?.status === 'Approved'
									? 'Confirm Update'
									: 'Confirm Request'
							"
							class="tw-text-sm"
							@click="processUpload"
						/>
					</div>
				</div>
			</div>
		</Modal>
	</main>
</template>

<script>
import CustomButton from "@/components/general/BtnComponent";
import DragNDrop from "@/components/general/DragNDrop";
import Dropdown from "@/components/general/Dropdown";
import InputField from "@/components/general/InputField";
import Modal from "@/components/general/Modal";
import RangeField from "@/components/general/RangeField";
import { convertToLocale, formatAmountToDollar } from "@/utils/helpers.js";
import countryRegionState from "@/utils/js/countryRegionData";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "TokenRequest",
	data() {
		return {
			countryRegionState,
			uploadImage: false,
			token: {
				name: null,
				symbol: null,
				image: "",
				raise_amount: null,
				valuation: null,
				min_buy: null,
				asset_id: null,
				secondaries: false,
				deal_access: true,
				buy_fee: 1,
				platform_fee: 0,
				investment_type: null,
				type: "Private",
				risk: "",
				currency: "",
				interest: null,
				tenor: null,
				discount: null,
				payout_frequency: "",
			},
			isValidated: false,
			validateForm: false,
			validationResult: [],
			suggestedSymbolName: "",
			tokenNameItems: null,
			assetName: "",
			valuation: null,
			raise_amount: null,
			min_buy: null,
			deal_access: null,
			investmentTypes: ["Equity", "Debt", "SAFE", "Fixed Interest"],
			secondariesTooltip:
				"Secondaries (Secondary market) allow investors to sell some of their initially bought shares to other investors at a price agreed by the buyer and seller.  Limited partners do not have a way to sell their own share of the deal anytime they like for cash or any other asset. ",
			dealAccessText:
				"This deal would be available to all members of your deal room",
			buyFeesText:
				"Click here to split transaction fees between you and your investors or transfer the fees completely.",
			buy_fee: null,
			minimumRaise: 25000,
			showDealPreview: false,
			currencies: [
				{ name: "United States Dollars", value: "USD" },
				{
					name: "Nigerian Naira",
					value: "NGN",
				},
				{
					name: "Kenyan Shillings",
					value: "KES",
				},
			],
			payoutFrequencies: [
				{ name: "Daily", value: "Daily" },
				{
					name: "Weekly",
					value: "Weekly",
				},
				{
					name: "Monthly",
					value: "Monthly",
				},
				{
					name: "Quarterly",
					value: "Quarterly",
				},
				{
					name: "Annually",
					value: "Annually",
				},
			],
		};
	},
	emits: ["token-request-submit"],
	components: {
		InputField,
		DragNDrop,
		Dropdown,
		CustomButton,
		Modal,
		RangeField,
	},
	props: {
		requestType: {
			// token or deal
			type: String,
			required: true,
		},
	},
	computed: {
		...mapGetters("TokenModule", { tokenInfo: "token" }),
		...mapGetters("organisationModule", [
			"organisationDetails",
			"transactionFees",
		]),
		...mapGetters("assetModule", ["asset"]),
		valuationFormatted() {
			let valuationFormatted = null;
			if (this.valuation) {
				const valuation = Number(String(this.valuation).split(",").join(""));
				this.token.valuation = valuation;
				valuationFormatted = this.convertToLocale(valuation);
			}
			return valuationFormatted;
		},
		raiseAmountFormatted() {
			let raiseAmountFormatted = null;
			if (this.raise_amount) {
				const raise_amount = Number(
					String(this.raise_amount).split(",").join("")
				);
				this.token.raise_amount = raise_amount;
				if (this.token.investment_type === "Debt") {
					this.token.valuation = raise_amount + 1;
				}
				raiseAmountFormatted = this.convertToLocale(raise_amount);
			}
			return raiseAmountFormatted;
		},
		minBuyFormatted() {
			let minimumBuy = null;
			if (this.min_buy) {
				const min_buy = Number(String(this.min_buy).split(",").join(""));
				this.token.min_buy = min_buy;
				minimumBuy = this.convertToLocale(min_buy);
			}
			return minimumBuy;
		},
		sharePrice() {
			return this.token.currency === 'NGN' ? 10000 : 10;
		},
		sharePriceFormatted() {
			if (this.token.currency === 'NGN') {
				return '₦10,000';
			}
			return '$10';
		},
		currencySymbol() {
			switch (this.token.currency) {
				case 'NGN':
					return '₦';
				case 'KES':
					return 'KSh';
				default:
					return '$';
			}
		},
	},
	created() {
		if (this.$route.query.asset) {
			this.getAsset(this.$route.query.asset);
		} else {
		}
		this.token.deal_access = "Private";
		this.token.platform_fee = 5;
		this.getTransactionFees();
	},
	mounted() {
		if (this.$route.name === "ConfigurePrivateRaise") {
			this.getTokenRequest(this.$route.params.id);
			if (this.tokenInfo) {
				this.setValues();
			}
		} else if (this.asset) {
			this.setValues();
		}
	},
	watch: {
		suggestedSymbolName: "checkSuggestedSymbolLength",
		deal_access(val) {
			if (val) {
				this.token.deal_access = "Public";
			} else {
				this.token.deal_access = "Private";
			}
		},
		asset(val) {
			if (val && this.$route.name !== "ConfigurePrivateRaise") {
				this.setValues();
			}
		},
		transactionFees(val) {
			if (val && !this.tokenInfo?.buy_fee && !this.buy_fee) {
				this.token.platform_fee = 5;
				this.token.buy_fee = this.transactionFees * 100;
			}
		},
		"token.name"(val) {
			if (val?.length > 0) {
				this.createTokenSymbol();
			}
		},
		valuationFormatted(val) {
			this.valuation = val;
		},
		raiseAmountFormatted(val) {
			this.raise_amount = val;
		},
		minBuyFormatted(val) {
			this.min_buy = val;
		},
		buy_fee(val) {
			if (!val && !this.tokenInfo?.buy_fee) {
				this.token.platform_fee = 5;
				this.token.buy_fee = this.transactionFees * 100;
			}
		},
		"token.raise_amount"(val) {
			if (
				this.token.investment_type === "Debt" ||
				this.token.investment_type === "Fixed Interest"
			) {
				this.token.valuation = Number(val) + 1;
			}
		},
		"token.buy_fee"(val) {
			if ((this.buy_fee && val && val > 0) || this.tokenInfo?.buy_fee) {
				if (val > 1) {
					this.token.platform_fee = 5 - this.token.buy_fee;
				} else {
					this.token.platform_fee = 5;
				}
			}
		},
		tokenInfo(val) {
			if (val.buy_fee !== 1) {
				this.buy_fee = false;
			} else {
				this.buy_fee = true;
			}
		},
		validationResult: {
			deep: true,
			handler(val) {
				// 7 is min number of required fields in the form
				if (val.length >= 11 && !val.includes(false)) {
					if (!this.buy_fee) {
						this.token.platform_fee = 5;
						this.token.buy_fee = this.transactionFees * 100;
					}
					this.showDealPreview = true;
				}
			},
		},
		"token.investment_type"(val) {
			val = val?.toLowerCase();
			if (val === "equity" || val === "safe") {
				this.token.risk = "High";
			} else {
				this.token.risk = "Medium";
			}
		},
		tokenInfo(val) {
			if (val) {
				this.prefillForm();
			}
		},
	},
	methods: {
		...mapActions(["showToast", "setLoading"]),
		...mapActions("assetModule", ["getAsset"]),
		...mapActions("organisationModule", ["getTransactionFees"]),
		...mapActions("TokenModule", ["getTokenRequest"]),
		convertToLocale,
		formatAmountToDollar,
		imageUploadError() {
			this.uploadImage = false;
			this.setLoading(false);
		},
		setValues() {
			this.token.name = this.asset.name;
			this.token.asset_id = this.asset._id;
			this.token.image = this.asset.image;
		},
		storeValue(val) {
			if (
				val.name === "valuation" ||
				val.name === "raise_amount" ||
				val.name === "min_buy" ||
				val.name === "percentage"
			) {
				this[val.name] = val.value;
			} else {
				this.token[val.name] = val.value;
			}
		},
		createTokenSymbol() {
			let suggestedSymbolName = "";
			this.suggestedSymbolName = "";
			this.assetName = this.token.name;
			const tokenName = this.assetName;
			const tokenNameItems = tokenName.split(" ");
			tokenNameItems.map((item) => {
				if (suggestedSymbolName.length < 6) {
					suggestedSymbolName += item.charAt(0).toUpperCase();
				}
			});
			this.suggestedSymbolName = suggestedSymbolName;
			this.tokenNameItems = tokenNameItems;
			this.token.symbol = suggestedSymbolName;
			this.checkSuggestedSymbolLength();
		},
		checkSuggestedSymbolLength() {
			let suggestedSymbolName = this.suggestedSymbolName;
			const tokenNameItems = this.tokenNameItems;
			const suggestedSymbolNameLength = suggestedSymbolName.length.toString();
			const mergedTokenName = tokenNameItems.join("");
			const mergedTokenNameLength = mergedTokenName.length;
			const secondLetter = tokenNameItems[0].charAt(1);
			const midPoint = Math.round(mergedTokenNameLength / 2);
			const middleLetter = mergedTokenName.charAt(midPoint);
			const endPoint = mergedTokenNameLength - 1;
			const lastLetter = mergedTokenName.charAt(endPoint);
			switch (suggestedSymbolNameLength) {
				case "1":
					suggestedSymbolName += secondLetter.toUpperCase();
					break;
				case "2":
					suggestedSymbolName += middleLetter.toUpperCase();
					break;
				case "3":
					suggestedSymbolName += lastLetter.toUpperCase();
					break;
			}
			this.suggestedSymbolName = suggestedSymbolName;
			this.token.symbol = suggestedSymbolName;
		},
		checkFormValidation() {
			this.validationResult = [];
			this.validateForm = true;
			this.isValidated = true;
			if (this.token.image) {
				this.handleValidation(true);
			} else {
				this.handleValidation(false);
			}
			if (
				this.token.investment_type === "Debt" ||
				this.token.investment_type === "Fixed Interest"
			) {
				this.handleValidation(true);
				this.handleValidation(true);
			} else {
				delete this.token.interest;
				delete this.token.tenor;
			}
			// Set discount to 0 for SAFE and Equity
			if (this.token.investment_type === "SAFE" || this.token.investment_type === "Equity") {
				this.token.discount = 0;
			} else {
				delete this.token.discount;
			}
			setTimeout(() => {
				this.validateForm = false;
			}, 1000);
		},
		setImage(url) {
			this.token.image = url;
		},
		uploadComplete(url) {
			this.token.image = url;
			this.uploadImage = false;
			const token = Object.assign({}, this.token);
			// Set payout_frequency to Annually for SAFE investments
			if (token.investment_type === "SAFE") {
				token.payout_frequency = "Annually";
			}
			this.$emit("token-request-submit", token);
		},
		handleValidation(value) {
			this.validationResult.push(value);
		},
		getCurrency(symbol) {
			let currency = null;
			switch (symbol) {
				case "NGN":
					currency = "Nigerian Naira";
					break;
				case "USD":
					currency = "United States Dollars";
					break;
			}
			return currency;
		},
		processUpload() {
			this.uploadImage = true;
			this.showDealPreview = false;
			this.setLoading(true);
		},
		prefillForm() {
			this.token.name = this.tokenInfo.name;
			this.token.symbol = this.tokenInfo.symbol;
			this.token.asset_id = this.tokenInfo.asset._id;
			this.valuation = this.tokenInfo.valuation;
			this.raise_amount = this.tokenInfo.raise_amount;
			this.token.image = this.tokenInfo.image;
			this.token.investment_type = this.tokenInfo.investment_type;
			this.token.image = this.tokenInfo.image;
			// this.token.min_buy = this.tokenInfo.min_trade.buy;
			this.min_buy = this.tokenInfo?.min_trade?.buy;
			this.token.secondaries = this.tokenInfo.secondaries;
			this.token.interest = this.tokenInfo.interest;
			this.token.tenor = this.tokenInfo.tenor;
			this.token.discount = this.tokenInfo.discount;
			this.token.risk = this.tokenInfo.risk;
			this.token.country = this.tokenInfo?.country;
			this.token.currency = this.tokenInfo?.currency;
			if (this.tokenInfo.buy_fee) {
				this.token.buy_fee = this.tokenInfo.buy_fee;
				// this.token.platform_fee = this.tokenInfo.platform_fee;
				if (this.tokenInfo.buy_fee > 1) {
					this.buy_fee = true;
				} else {
					this.buy_fee = false;
				}
			}
			if (this.tokenInfo.payout_frequency) {
				this.token.payout_frequency = this.tokenInfo.payout_frequency;
			}
			this.token.deal_access = this.tokenInfo.deal_access;
			if (this.tokenInfo.deal_access === "Public") {
				this.deal_access = true;
			} else {
				this.deal_access = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.token-request {
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	max-width: 820px;
	margin: 0 auto;
	
	&__header {
		display: flex;
		align-items: flex-start;
		gap: 16px;
		margin-bottom: 32px;
	}
	
	&__header-icon {
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
		border-radius: 12px;
		color: #ffffff;
		flex-shrink: 0;
	}
	
	&__title {
		font-size: 20px;
		font-weight: 500;
		color: #0F172A;
		margin: 0 0 4px 0;
	}
	
	&__subtitle {
		font-size: 14px;
		color: #64748B;
		margin: 0;
	}
	
	&__form {
		background: #ffffff;
		border: 1px solid #E2E8F0;
		border-radius: 16px;
		overflow: hidden;
	}
	
	&__section {
		padding: 24px;
		border-bottom: 1px solid #E2E8F0;
	}
	
	&__section-header {
		display: flex;
		align-items: center;
		gap: 10px;
		color: #4D84FF;
		
		h2 {
			font-size: 16px;
			font-weight: 500;
			color: #0F172A;
			margin: 0;
		}
	}
	
	&__content {
		padding: 32px;
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		justify-content: center;
		
		@media (min-width: 768px) {
			gap: 40px;
			padding: 40px;
		}
	}
	
	&__checkbox {
		accent-color: #4D84FF;
		width: 18px;
		height: 18px;
		cursor: pointer;
	}
}

// Override child component styles for consistent look
:deep(.input-field),
:deep(.dropdown) {
	margin-bottom: 0;
}

:deep(label) {
	font-size: 13px;
	font-weight: 500;
	color: #64748B;
	margin-bottom: 8px;
}

:deep(input),
:deep(select) {
	border: 1px solid #E2E8F0;
	border-radius: 10px;
	padding: 12px 16px;
	font-size: 14px;
	transition: all 0.2s ease;
	
	&:focus {
		border-color: #4D84FF;
		box-shadow: 0 0 0 3px rgba(77, 132, 255, 0.1);
	}
}

// Alert box styling
.tw-bg-\[\#fdf2e7\] {
	background: rgba(245, 158, 11, 0.08) !important;
	border: 1px solid rgba(245, 158, 11, 0.2);
	border-radius: 10px;
}

// Preview Modal Styling
.create-deal-preview__modal {
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	
	h1 {
		font-size: 20px;
		font-weight: 500;
		color: #0F172A;
	}
	
	h2 {
		font-size: 12px;
		color: #64748B;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		margin-bottom: 4px;
	}
	
	p {
		font-size: 15px;
		font-weight: 500;
		color: #0F172A;
	}
	
	.border-bottom {
		padding-bottom: 16px;
		border-bottom: 1px solid #E2E8F0;
	}
	
	.preview-button {
		background: transparent;
		color: #64748B;
		border: 1px solid #E2E8F0;
		border-radius: 10px;
		padding: 14px 24px;
		font-weight: 500;
		transition: all 0.2s ease;
		
		&:hover {
			background: #F8FAFC;
			border-color: #CBD5E1;
			color: #0F172A;
		}
	}
}
</style>
